import miscServices from '@/services/misc'
import _ from 'lodash'
/*
This store module will enable fast shedule UI/UX
All schedule related components will get their data
from her, and update these objects as they are updated
from the respective components
*/

function initialState () {
  return {
    selectedWOs: [],
    selectedRoutes: [],
    scheduleError: false,
  }
}

const state = initialState()

const getters = {
  areWOsSelected: state => state.selectedWOs.length > 0 ? true : false
}

const actions = {
  resetSchedule (context) {
    context.commit('resetSchedule')
  },
  selectWO (context, payload) {
    context.commit('selectWO', payload)
  },
  addWOGroup (context, payload) {
    context.commit('addWOGroup', payload)
  },
  deselectWO (context, payload) {
    context.commit('deselectWO', payload)
  },
  deselectAll (context) {
    context.commit('deselectAll')
  },
  removeWOGroup (context, payload) {
    context.commit('removeWOGroup', payload)
  },
  selectRoute (context, payload) {
    context.commit('selectRoute', payload)
  },
  selectScheduleError (context) {
    context.commit('selectScheduleError')
  },
  deselectScheduleError (context) {
    context.commit('deselectScheduleError')
  }
}

const mutations = {
  resetSchedule (state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  selectWO (state, payload) {
    state.selectedWOs.push(payload)
  },
  addWOGroup (state, payload) {
    state.selectedWOs = state.selectedWOs.concat(payload)
  },
  deselectWO (state, payload) {
    let tmp = state.selectedWOs.find(w => w.id === payload.id)
    state.selectedWOs = miscServices.removeObject(state.selectedWOs, tmp)
  },
  deselectAll (state) {
    state.selectedWOs = []
    state.selectedRoutes = []
  },
  removeWOGroup (state, payload) {
    payload.forEach((p) => miscServices.removeObject(state.selectedWOs, p))
  },
  selectRoute (state, payload) {
    let routeAlreadyInStore = _.find(state.selectedRoutes, r => payload.id === r.id)
    if (routeAlreadyInStore) {
      state.selectedRoutes = miscServices.replaceObject(state.selectedRoutes, payload)
    } else { 
      state.selectedRoutes.push(payload)
    }
  },
  selectScheduleError (state) {
    state.scheduleError = true
  },
  deselectScheduleError (state) {
    state.scheduleError = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
